import DoneIcon from 'assets/ver2/icons/done-fill-icon.svg';
import CapturePhotoIDCorrectImg from 'assets/ver2/images/capture-photo-id-correct.svg';
import CapturePhotoIDIncorrectImg from 'assets/ver2/images/capture-photo-id-incorrect.svg';
import CapturePhotoSelfieCorrectImg from 'assets/ver2/images/capture-photo-selfie-correct.svg';
import CapturePhotoSelfieIncorrectImg from 'assets/ver2/images/capture-photo-selfie-incorrect.svg';
import ButtonCommon from 'components/common/ButtonCommon';
import SizeBox from 'components/common/SizeBox';
import {
  DESKTOP_MIN_WIDTH,
  MOBILE_MIN_WIDTH,
  TABLET_MAX_WIDTH,
} from 'constants';
import useLang from 'hooks/useLang';
import Modal from 'react-bootstrap/Modal';
import styled from 'styled-components';
import {
  displayFlexColCenterCenterMixin,
  displayFlexRowCenterCenterMixin,
  displayFlexRowStartStartMixin,
  paragraph500Mixin,
  paragraph700Mixin,
} from 'styles';

const InstructionToCapturePhotoPopup = ({ isOpen, onClose, modalData }) => {
  const { t } = useLang();

  let { captureType } = modalData || {};
  const isCaptureTypeID = captureType === 'id';

  const getCaturePhotoImg = () => {
    if (isCaptureTypeID)
      return {
        correctSrc: CapturePhotoIDCorrectImg,
        incorrectSrc: CapturePhotoIDIncorrectImg,
      };
    return {
      correctSrc: CapturePhotoSelfieCorrectImg,
      incorrectSrc: CapturePhotoSelfieIncorrectImg,
    };
  };
  const renderInstructionRequires = () => {
    if (isCaptureTypeID)
      return (
        <>
          <SubText>
            <img src={DoneIcon} width={20} height={20} />
            {t('label_instruction_to_capture_photo_id_requires_1')}
          </SubText>
          <SizeBox height={10} />
          <SubText>
            <img src={DoneIcon} width={20} height={20} />
            {t('label_instruction_to_capture_photo_id_requires_2')}
          </SubText>
        </>
      );
    return (
      <>
        <SubText>
          <img src={DoneIcon} width={20} height={20} />
          {t('label_instruction_to_capture_photo_selfie_requires_1')}
        </SubText>
        <SizeBox height={10} />
        <SubText>
          <img src={DoneIcon} width={20} height={20} />
          {t('label_instruction_to_capture_photo_selfie_requires_2')}
        </SubText>
      </>
    );
  };
  const renderBodyContent = () => (
    <>
      <Text>{t('label_notice')}</Text>
      <SizeBox height={10} />
      <SubText>{t('label_instruction_to_capture_photo_requires')}</SubText>
      <SizeBox height={10} />
      {renderInstructionRequires()}
      <SizeBox height={10} />
      <Images>
        <img src={getCaturePhotoImg().correctSrc} />
        <img src={getCaturePhotoImg().incorrectSrc} />
      </Images>
      <SizeBox height={20} />
    </>
  );

  const renderActionButton1 = (width) => (
    <ButtonCommon
      value={t('button_got_it')}
      onClick={onClose}
      styles={{
        margin: '0px',
        height: '50px',
        width,
      }}
      color="var(--c-primary)"
      background="var(--bg-primary)"
      isFill={true}
    />
  );
  const renderActionButtons = () => {
    return <>{renderActionButton1('100%')}</>;
  };

  return (
    <>
      <style>
        {`
          .instruction-to-capture-photo-popup {
            z-index: 1071;
          }
        `}
        {`
          .instruction-to-capture-photo-popup-backdrop {
            z-index: 1070;
            background: #212121;
            opacity: 0.7!important;
            display: initial!important;
          }
        `}
      </style>
      <ModalStyled
        show={isOpen}
        onHide={() => {}}
        aria-labelledby="contained-modal-title-vcenter"
        className="instruction-to-capture-photo-popup"
        backdropClassName="instruction-to-capture-photo-popup-backdrop"
        centered
      >
        <ModalBody>{renderBodyContent()}</ModalBody>
        <ModalFooter>{renderActionButtons()}</ModalFooter>
      </ModalStyled>
    </>
  );
};

const ModalStyled = styled(Modal)`
  padding-left: 0 !important;
  padding-right: 0px !important;

  @media screen and (min-width: ${MOBILE_MIN_WIDTH}px) and (max-width: ${TABLET_MAX_WIDTH -
    1}px) {
    & .modal-dialog {
      position: absolute;
      margin: 0;
      top: 0px;
      height: 100dvh;
      width: 100%;
      max-width: 100%;
      align-items: end;
      transition: ease-out 0.3s !important;
      transform: none;

      & .modal-content {
        padding: 0px 16px;
        border-radius: 0px;
        box-shadow: none;
        background: var(--ds-c-white);
        width: 100%;
        height: fit-content;
        margin-inline: auto;
        border: none;
        border-radius: 16px 16px 0 0;
      }
    }
  }

  @media screen and (min-width: ${DESKTOP_MIN_WIDTH}px) {
    & .modal-dialog {
      transform: none;
      & .modal-content {
        padding: 16px;
        box-shadow: var(--ds-bs-4);
        background: var(--ds-c-white);
        width: 436px;
        height: fit-content;
        margin-inline: auto;
        border: none;
        border-radius: 8px;
      }
    }
  }
`;
const ModalBody = styled(Modal.Body)`
  padding: 0;
  text-align: left;
  margin-bottom: 0px;
  padding-top: 16px;

  @media screen and (min-width: ${DESKTOP_MIN_WIDTH}px) {
    padding-top: unset;
  }
`;

const Text = styled.p`
  ${paragraph700Mixin};
`;
const SubText = styled.p`
  ${paragraph500Mixin};
  ${displayFlexRowStartStartMixin};
  gap: 4px;
`;

const Images = styled.div`
  ${displayFlexRowCenterCenterMixin};
  gap: 10px;
  & img {
    width: 50%;
  }
`;

const ModalFooter = styled(Modal.Footer)`
  ${displayFlexColCenterCenterMixin};
  margin-inline: -16px;
  padding-inline: 16px;
  padding-block: 16px 20px;
  border: none;

  @media screen and (min-width: ${DESKTOP_MIN_WIDTH}px) {
    padding-block: unset;
    padding-inline: unset;
    margin-inline: unset;
    flex-direction: row;
  }
`;

export default InstructionToCapturePhotoPopup;
